import { type ShareUrlGeneratedVersion } from '@air/analytics';
import { type ShortUrlObjectType } from '@air/api/types';

import { type AssetShareLinkSlotId } from '~/components/SharePrivateClipModal/buildAssetShareLinkSlots';

export const getShareUrlGeneratedVersionFromClipVersion = (version: number): ShareUrlGeneratedVersion => `v${version}`;

type ResolveShareUrlGeneratedVersionParams = {
  versionSlot?: AssetShareLinkSlotId;
  clipVersion?: number;
  objectType: 'clip' | 'asset';
};

export const resolveShareUrlGeneratedVersion = ({
  versionSlot,
  clipVersion,
  objectType,
}: ResolveShareUrlGeneratedVersionParams): ShareUrlGeneratedVersion => {
  if (versionSlot) {
    return versionSlot;
  }

  if (objectType === 'asset') {
    return 'current';
  }

  if (typeof clipVersion === 'number') {
    return getShareUrlGeneratedVersionFromClipVersion(clipVersion);
  }

  throw new Error('Unable to resolve share url generated version');
};

type ShortUrlWithOptionalVersion = {
  objectType?: ShortUrlObjectType | string;
  version?: number;
};

export const getShareUrlGeneratedVersionFromShortUrl = (
  shortUrl: ShortUrlWithOptionalVersion,
  objectType: 'clip' | 'asset',
): ShareUrlGeneratedVersion | undefined => {
  if (objectType === 'asset') {
    return 'current';
  }

  if (typeof shortUrl.version === 'number') {
    return getShareUrlGeneratedVersionFromClipVersion(shortUrl.version);
  }

  return undefined;
};
